const topics = [
  { name: '校园恋爱', count: '3,286', icon: 'ri-hearts-line' },
  { name: '奇幻冒险', count: '2,951', icon: 'ri-sword-line' },
  { name: '悬疑推理', count: '1,847', icon: 'ri-search-eye-line' },
  { name: '恶役千金', count: '1,623', icon: 'ri-award-line' },
  { name: '都市职场', count: '1,405', icon: 'ri-building-line' },
  { name: '古风宫斗', count: '1,198', icon: 'ri-vip-crown-line' },
  { name: '重生逆袭', count: '1,082', icon: 'ri-refresh-line' },
  { name: '治愈日常', count: '964', icon: 'ri-sun-line' },
  { name: '动作热血', count: '876', icon: 'ri-fire-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            韩漫爱好者最关注的题材标签与讨论热度，快速找到感兴趣的分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-center gap-3 p-3 md:p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 group-hover:bg-primary-200/80 transition-colors flex-shrink-0">
                <i className={`${topic.icon} text-base md:text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-medium text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.name}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{topic.count} 部作品</div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}